export interface IPageHeaderProps {
  title: string;
  description?: string;
}

const pageHeader = (props: IPageHeaderProps) => {
  return (
    <div className="grid grid-cols-1">
      <span className="text-2xl md:text-4xl font-bold text-black">{props.title}</span>
      <span className="mt-2 text-sm md:text-base" style={{ color: '#707070' }}>
        {props.description}
      </span>
    </div>
  );
};

export default pageHeader;
